import {combineReducers} from "redux";
import UserReducer from "./users/user.reducer";
import SiteReducer from "./site/site.reducer";
import ModalReducer from "./modals/modals.reducer";
import CartReducer from './cart/cart.reducer'
import {persistReducer} from "redux-persist";
import storage from 'redux-persist/lib/storage';

const persistConfig ={
    key: 'root',
    storage,
    whitelist: ['user']
};

const rootReducer = combineReducers({
    user : UserReducer,
    site : SiteReducer,
    modals : ModalReducer,
    cart : CartReducer
});

export default persistReducer(persistConfig,rootReducer);